export function CheckedIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#81D201" />
      <path
        d="M17.9251 8.61785C17.8748 8.49645 17.801 8.38616 17.7081 8.29329C17.6152 8.20031 17.5049 8.12655 17.3835 8.07623C17.2621 8.0259 17.132 8 17.0006 8C16.8691 8 16.739 8.0259 16.6176 8.07623C16.4962 8.12655 16.3859 8.20031 16.2931 8.29329L10.0006 14.587L7.70806 12.2933C7.52042 12.1056 7.26592 12.0002 7.00056 12.0002C6.73519 12.0002 6.4807 12.1056 6.29306 12.2933C6.10541 12.4809 6 12.7354 6 13.0008C6 13.2662 6.10541 13.5206 6.29306 13.7083L9.29306 16.7083C9.38593 16.8013 9.49622 16.875 9.61762 16.9253C9.73901 16.9757 9.86914 17.0016 10.0006 17.0016C10.132 17.0016 10.2621 16.9757 10.3835 16.9253C10.5049 16.875 10.6152 16.8013 10.7081 16.7083L14.2081 13.2083L17.7081 9.70829C17.801 9.61541 17.8748 9.50513 17.9251 9.38373C17.9754 9.26233 18.0013 9.1322 18.0013 9.00079C18.0013 8.86937 17.9754 8.73924 17.9251 8.61785Z"
        fill="white"
      />
    </svg>
  )
}
